import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["input", "dropzone", "idle", "uploading"]
    static values = { url: String }

    browse() {
        this.inputTarget.click()
    }

    filesSelected() {
        const files = this.inputTarget.files
        if (files.length > 0) {
            this.uploadFiles(files)
        }
    }

    dragover(event) {
        event.preventDefault()
    }

    dragenter(event) {
        event.preventDefault()
        this.dropzoneTarget.classList.add("border-blue-500", "bg-blue-50/50", "dark:bg-blue-900/10")
        this.dropzoneTarget.classList.remove("border-gray-300", "dark:border-slate-600")
    }

    dragleave(event) {
        event.preventDefault()
        this.dropzoneTarget.classList.remove("border-blue-500", "bg-blue-50/50", "dark:bg-blue-900/10")
        this.dropzoneTarget.classList.add("border-gray-300", "dark:border-slate-600")
    }

    drop(event) {
        event.preventDefault()
        this.dragleave(event)

        const files = event.dataTransfer.files
        if (files.length > 0) {
            this.uploadFiles(files)
        }
    }

    async uploadFiles(files) {
        this.showUploading()

        const uploads = Array.from(files)
            .filter(f => f.type.match(/^image\/(png|jpeg|webp)$/))
            .map(file => this.uploadFile(file))

        await Promise.all(uploads)

        this.showIdle()
        this.inputTarget.value = ""
    }

    async uploadFile(file) {
        const formData = new FormData()
        formData.append("image", file)

        const csrfToken = document.querySelector("meta[name='csrf-token']")?.content

        try {
            const response = await fetch(this.urlValue, {
                method: "POST",
                headers: {
                    "X-CSRF-Token": csrfToken,
                    "Accept": "text/vnd.turbo-stream.html"
                },
                body: formData
            })

            if (response.ok) {
                const html = await response.text()
                Turbo.renderStreamMessage(html)
            }
        } catch (error) {
            console.error("Upload failed:", error)
        }
    }

    showUploading() {
        this.idleTarget.classList.add("hidden")
        this.uploadingTarget.classList.remove("hidden")
        this.uploadingTarget.classList.add("flex")
    }

    showIdle() {
        this.uploadingTarget.classList.add("hidden")
        this.uploadingTarget.classList.remove("flex")
        this.idleTarget.classList.remove("hidden")
    }
}
